import { useCallback, useEffect, useState } from 'react';
import api from '../../utils/axios';

export const ESTADO_EPISODIO = {
  ACTIVO: { label: 'Activo', c: 'bg-orange-100 text-orange-800 border-orange-200' },
  VENCIDO: { label: 'Vencido', c: 'bg-slate-100 text-slate-600 border-slate-200' },
  DESCARTADO: { label: 'Descartado', c: 'bg-zinc-100 text-zinc-500 border-zinc-200' },
  CERRADO_ANALISTA: { label: 'Revisado', c: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
};

export const SEVERIDAD = {
  CRITICA: 'bg-red-600 text-white',
  ALTA: 'bg-orange-500 text-white',
  MEDIA: 'bg-amber-300 text-amber-950',
  BAJA: 'bg-lime-200 text-lime-900',
};

export const EPISODIO_CERRADO = ['DESCARTADO', 'CERRADO_ANALISTA'];

// Fechas "AAAA-MM-DD" se muestran tal cual (sin corrimiento por zona horaria).
export const fFecha = (f) => {
  if (!f) return '—';
  const s = String(f);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(2, 4)}`;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit' });
};

export const fFechaHora = (f) => (f ? new Date(f).toLocaleString('es-AR', {
  day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit',
}) : '—');

export const periodoEpisodio = (e) => `${fFecha(e.periodo_desde)} – ${fFecha(e.periodo_hasta)}`;

export const esCircular = (e) => [e?.monitor, e?.tipo, e?.logica_especial]
  .some((x) => String(x || '').toLowerCase().includes('circular'));

export const digitos = (v) => String(v || '').replace(/\D/g, '');

// Episodios del caso en vista lista/detalle (GET /cases/{id}/episodios).
export const useEpisodiosCaso = (caseId) => {
  const [state, setState] = useState({ episodios: [], motivos: {}, loading: true });
  const recargar = useCallback(() => (caseId ? api.get(`/cases/${caseId}/episodios`)
    .then((r) => setState({ episodios: r.data.episodios || [], motivos: r.data.motivos || {}, loading: false }))
    .catch(() => setState((s) => ({ ...s, loading: false }))) : Promise.resolve()), [caseId]);
  useEffect(() => { setState((s) => ({ ...s, loading: true })); recargar(); }, [recargar]);
  return { ...state, recargar };
};

// E1: franja de riesgo del caso (GET /cases/{id}/franja-riesgo); `version` fuerza la recarga.
export const useFranjaCaso = (caseId, version) => {
  const [franja, setFranja] = useState(null);
  useEffect(() => {
    if (!caseId) return undefined;
    let vivo = true;
    api.get(`/cases/${caseId}/franja-riesgo`).then((r) => vivo && setFranja(r.data)).catch(() => vivo && setFranja({}));
    return () => { vivo = false; };
  }, [caseId, version]);
  return franja;
};
